export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyDZ4aWN_GqaXRo9kxgRDiIKKl2JgutPDg8",
    authDomain: "elawhands-realupdate.firebaseapp.com",
    databaseURL:
        "https://elawhands-realupdate-default-rtdb.asia-southeast1.firebasedatabase.app",
    storageBucket: "elawhands-realupdate.appspot.com",
}

export const FIREBASE_PNotifyCountDown = 1000;